import { useCallback } from "react";

import config from "config/appConfig";

import { useNavigate } from "react-router-dom";

import type ApiError from "../core/ApiError";

const { GLOBAL_CONSTANTS, CORE_URLS } = config;

const useRestrictedInterceptor = () => {
	const navigate = useNavigate();

	return useCallback(
		({ status }: ApiError) => {
			if (status === 451) {
				for (const key in localStorage) {
					if (key.includes(GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX ?? "")) localStorage.removeItem(key);
				}
				navigate(`${CORE_URLS.HOME}?restricted`);
			}
		},
		[navigate]
	);
};

export default useRestrictedInterceptor;
